var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * @file  pagination
 * @author chenyaqiu
 */
import * as React from 'react';
import classNames from 'classnames';
import OutlinedLeft from 'acud-icon/lib/icons/OutlinedLeft';
import OutlinedRight from 'acud-icon/lib/icons/OutlinedRight';
import OutlinedLeftDouble from 'acud-icon/lib/icons/OutlinedLeftDouble';
import OutlinedRightDouble from 'acud-icon/lib/icons/OutlinedRightDouble';
import OutlinedEllipsisSquare from 'acud-icon/lib/icons/OutlinedEllipsisSquare';
import { ConfigContext } from '../config-provider';
import RcPagination from './rc-pagination';
import Select from '../select';
import LocaleReceiver from '../locale-provider/LocaleReceiver';
import SizeContext from '../config-provider/SizeContext';
export const Option = Select.Option;
const Pagination = (_a) => {
    var { prefixCls: customizePrefixCls, selectPrefixCls: customizeSelectPrefixCls, className, size: customizeSize, showQuickJumper, showSizeChanger } = _a, restProps = __rest(_a, ["prefixCls", "selectPrefixCls", "className", "size", "showQuickJumper", "showSizeChanger"]);
    const { getPrefixCls, direction } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('pagination', customizePrefixCls);
    const getIconsProps = () => {
        const ellipsis = (<span className={`${prefixCls}-item-ellipsis`}>
                <OutlinedEllipsisSquare />
            </span>);
        let prevIcon = (<button className={`${prefixCls}-item-link`} type="button" tabIndex={-1}>
                <OutlinedLeft />
            </button>);
        let nextIcon = (<button className={`${prefixCls}-item-link`} type="button" tabIndex={-1}>
                <OutlinedRight />
            </button>);
        let jumpPrevIcon = (<a className={`${prefixCls}-item-link`}>
                <div className={`${prefixCls}-item-container`}>
                    <OutlinedLeftDouble className={`${prefixCls}-item-link-icon`}/>
                    {ellipsis}
                </div>
            </a>);
        let jumpNextIcon = (<a className={`${prefixCls}-item-link`}>
                <div className={`${prefixCls}-item-container`}>
                    <OutlinedRightDouble className={`${prefixCls}-item-link-icon`}/>
                    {ellipsis}
                </div>
            </a>);
        return {
            prevIcon,
            nextIcon,
            jumpPrevIcon,
            jumpNextIcon
        };
    };
    // const renderQuickJumper = () => <Button type='default'>GO</Button>;
    const renderPagination = (locale, size) => {
        const mergedSize = customizeSize || size;
        const isSmall = mergedSize === 'small' || !!(!mergedSize && restProps.responsive);
        const selectPrefixCls = getPrefixCls('select', customizeSelectPrefixCls);
        const extendedClassName = classNames({
            mini: isSmall,
            ['rtl']: direction === 'rtl'
        }, className);
        return (<RcPagination showSizeChanger={showSizeChanger} locale={Object.assign(Object.assign({}, locale), restProps.locale)} {...restProps} prefixCls={prefixCls} selectPrefixCls={selectPrefixCls} {...getIconsProps()} className={extendedClassName} selectComponentClass={showSizeChanger ? Select : undefined} Option={Option} showQuickJumper={showQuickJumper}/>);
    };
    return (<LocaleReceiver componentName="Pagination">
            {locale => (<SizeContext.Consumer>
                    {size => renderPagination(locale, size)}
                </SizeContext.Consumer>)}
        </LocaleReceiver>);
};
export default Pagination;
